export default {
  // Brand & meta
  "brand.name": "USFansLink",
  "brand.tagline": "Independent USFans Spreadsheet Resource Hub",
  "meta.home.title": "USFans Spreadsheet: Guides, Reviews, Shipping & Latest Finds",
  "meta.home.description": "Explore the USFans Spreadsheet, product guides, QC tips, shipping information, warehouse resources, reviews and the latest USFans updates.",
  "meta.article.title": "USFans Spreadsheet Guide: What It Is and How to Use It",
  "meta.article.description": "A complete, independent guide to the USFans Spreadsheet — how it works, how to research products, category tips, QC checks, shipping and safety basics.",

  // Navigation
  "nav.home": "Home",
  "nav.guide": "USFans Spreadsheet Guide",
  "nav.buyingGuide": "Buying Guide",
  "nav.categories": "Categories",
  "nav.faq": "FAQ",
  "nav.explore": "Explore Spreadsheet",

  // Hero
  "hero.badge": "Independent Resource Hub",
  "hero.title": "USFans Spreadsheet — Find Products, Guides & Resources Faster",
  "hero.subtitle": "Your independent resource for the USFans Spreadsheet, product research, QC guides, shipping information, warehouse tips and USFans reviews.",
  "hero.supporting": "Looking for the USFans Spreadsheet? Start here. Explore organized product resources, learn how to research products, understand QC information, compare options and make better-informed decisions before buying.",
  "hero.cta.primary": "USFans Spreadsheet",
  "hero.cta.secondary": "Buy It Now",
  "hero.cta.guide": "Read the USFans Guide",
  "hero.trust": "Updated resources · Independent guides · Safety-focused information",

  // Category dropdown
  "categories.dropdown.label": "Browse Categories",
  "categories.dropdown.hint": "Select a category to open it on the main website",

  // Category names
  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  // Categories section
  "categories.title": "Popular Product Categories",
  "categories.subtitle": "Jump straight to a category on the main website. Every button opens the matching product page.",

  // About section
  "about.title": "What Is the USFans Spreadsheet?",
  "about.body": "The USFans Spreadsheet is a product discovery and research resource. It helps users organize product information, browse categories and research products before making a purchasing decision. Instead of jumping between scattered pages, you can review items, compare options and check details in one place.",
  "about.body2": "Our job at USFansLink is to make that process easier. We publish independent, beginner-friendly guides that explain how the spreadsheet works, how to read product information and what to verify before you spend money.",

  // Why section
  "why.title": "Why Use Our USFans Resources?",
  "why.subtitle": "Everything here is written to help you research with more confidence — without pushing you toward any single seller.",
  "why.items": [
    "Organized information",
    "Beginner-friendly guides",
    "Product research walkthroughs",
    "QC explanations",
    "Shipping information",
    "Warehouse guides",
    "Review resources",
    "Coupon awareness",
    "Safety information",
    "Regular updates"
  ],

  // Guide section
  "guide.title": "How to Use the USFans Spreadsheet",
  "guide.body": "A few simple habits make product research much faster. Here is a straightforward workflow you can follow, whether you are a first-time buyer or a regular researcher.",
  "guide.steps": [
    "Pick a category that matches what you are looking for.",
    "Use search and filters to narrow the list of products.",
    "Review the product information shown for each item.",
    "Check QC photos or details if they are available.",
    "Compare options and verify current information before buying."
  ],

  // Article entry
  "articleEntry.title": "Start With Our Complete Guide",
  "articleEntry.body": "New to the USFans Spreadsheet? Read our full, original guide covering how it works, category tips, QC checks, shipping and safety — written for people who want clear, honest information.",
  "articleEntry.button": "Read the Complete Guide",
  "articleEntry.meta": "Updated regularly · Independent · No affiliation",

  // FAQ
  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick answers to the questions people ask most about the USFans Spreadsheet.",
  "faq.items": [
    {
      "q": "What is the USFans Spreadsheet?",
      "a": "It is a product discovery and research resource that organizes product information, categories and links so buyers can research items before purchasing."
    },
    {
      "q": "How do I use the USFans Spreadsheet?",
      "a": "Start by choosing a category, then use search and filters to narrow results, review product details and QC information, and compare options before you buy."
    },
    {
      "q": "Is USFans safe to use?",
      "a": "The spreadsheet itself is a research tool. Always verify product, seller and payment information independently, and watch for fake websites and suspicious links."
    },
    {
      "q": "How much does USFans shipping cost?",
      "a": "Shipping costs vary by weight, dimensions, destination and method. Actual prices can change, so always check current information before ordering."
    },
    {
      "q": "Does USFans have coupon codes?",
      "a": "Promotions change often. We never invent coupon codes, so always verify any current offer on the official website before using it."
    }
  ],

  // Final CTA
  "cta.title": "Ready to Explore the USFans Spreadsheet?",
  "cta.body": "Explore our guides, comparisons, reviews and resources to make your USFans research easier.",
  "cta.button": "Explore USFans Spreadsheet",

  // Articles section
  "articles.title": "Latest USFans Guides",
  "articles.subtitle": "Independent, original guides on the USFans Spreadsheet, reviews, shipping, warehouse, QC, sellers and safety.",
  "articles.read": "Read",

  // Footer
  "footer.about": "USFansLink is an independent resource hub for the USFans Spreadsheet. We publish guides, reviews and safety information to help buyers research with confidence.",
  "footer.resources": "Resources",
  "footer.categories": "Categories",
  "footer.languages": "Languages",
  "footer.disclaimer": "This website provides independent informational resources. We do not guarantee the authenticity, safety, legality, quality, availability or performance of any third-party product, seller, website or service. Always verify current information independently before making a purchase.",
  "footer.rights": "All rights reserved.",

  // Article page
  "article.backHome": "Back to Home",
  "article.tocTitle": "Table of Contents",
  "article.updated": "Last updated",
  "article.published": "Published",
  "article.readTime": "min read",
  "article.h1": "USFans Spreadsheet Guide: What It Is and How to Use It",
  "article.intro": "The USFans Spreadsheet is a product discovery and research resource used by many buyers to browse organized product information, explore categories and research items before making a purchase. This independent guide explains what the spreadsheet is, how it works, how to use it, and what to check before you buy.",
  "article.intro2": "We are not affiliated with any seller or store. Our goal is simple: help you make better-informed decisions with clear, honest information.",
  "article.toc": [
    "What Is the USFans Spreadsheet?",
    "How the USFans Spreadsheet Works",
    "Product Categories Explained",
    "How to Use the USFans Spreadsheet",
    "Product Research and QC Tips",
    "Shipping and Warehouse Basics",
    "Safety Tips Before Buying",
    "Frequently Asked Questions"
  ],
  "article.s1Title": "What Is the USFans Spreadsheet?",
  "article.s1Text": "The USFans Spreadsheet is a structured resource that brings product information together in one place. Rather than visiting many separate pages, buyers can review products, categories and links from a single organized view. It is commonly used by people researching shoes, clothing and accessories.",
  "article.s1Text2": "It is important to understand that the spreadsheet is a research and discovery tool, not a store itself. It points to products and sellers, but the final purchase and any transaction happen on the websites it links to.",
  "article.s2Title": "How the USFans Spreadsheet Works",
  "article.s2Text": "The spreadsheet typically organizes products into rows, with each row showing details such as the product name, category, price information and a link to the listing. Filters and search help you narrow a long list down to the items that matter to you.",
  "article.s2Text2": "Some versions also include quality-check (QC) notes or photos, which give you a closer look at a product before you commit. Treat these as helpful references rather than guarantees — quality can vary between items.",
  "article.s3Title": "Product Categories Explained",
  "article.s3Text": "Products are usually grouped into clear categories so you can find what you need faster. The table below lists the main categories and what to look for in each one.",
  "article.s3Table.area": "Category",
  "article.s3Table.what": "What to look for",
  "article.s3Table.notes": "Notes",
  "article.s3Rows": [
    { "area": "Shoes", "what": "Model, size, color and condition", "notes": "Check sizing and QC photos" },
    { "area": "Hoodies / Sweaters", "what": "Fit, material and color", "notes": "Review size charts when available" },
    { "area": "T-Shirts", "what": "Size, print and material", "notes": "Verify measurements" },
    { "area": "Jackets", "what": "Style, size and season", "notes": "Confirm details before ordering" },
    { "area": "Bags & Accessories", "what": "Type, dimensions and color", "notes": "Check item descriptions" }
  ],
  "article.s4Title": "How to Use the USFans Spreadsheet",
  "article.s4Text": "You do not need any special tools to use the spreadsheet effectively. A simple, careful workflow is enough.",
  "article.s4Steps": [
    "Choose a category that matches what you are looking for.",
    "Use search and filters to narrow the product list.",
    "Open a product and read its full information.",
    "Check QC photos or notes when they are available.",
    "Compare two or three options before deciding.",
    "Verify the current price, availability and seller information."
  ],
  "article.s5Title": "Product Research and QC Tips",
  "article.s5Text": "Good product research comes down to checking details rather than trusting a single photo. Look at multiple images, read the description carefully, and compare the same product across sources when possible.",
  "article.s5Text2": "QC photos show you a closer view of the actual item, including stitching, labels and any visible marks. Use them to spot obvious issues early, but remember that a photo cannot replace reading the full listing.",
  "article.s6Title": "Shipping and Warehouse Basics",
  "article.s6Text": "Shipping cost depends on several factors, including weight, dimensions, destination and the shipping method you choose. The warehouse stage is where products may be stored, checked and prepared before they are sent to you.",
  "article.s6Text2": "Actual shipping prices and timelines can change. Always check current rates and delivery estimates before ordering, and keep tracking and customs considerations in mind for international orders.",
  "article.s7Title": "Safety Tips Before Buying",
  "article.s7Text": "Stay cautious at every step. Verify that you are on the correct website, double-check seller and product information, and avoid suspicious links or unsolicited messages that ask for personal details.",
  "article.s7Text2": "Use secure payment methods, keep records of your orders, and read refund or return information before you pay. If something feels off, pause and verify independently.",
  "article.faqTitle": "Frequently Asked Questions",
  "article.faq": [
    {
      "q": "Is the USFans Spreadsheet free to use?",
      "a": "The spreadsheet is a resource for browsing product information. Access details may vary, so check the current information on the official website."
    },
    {
      "q": "Can I trust every product in the spreadsheet?",
      "a": "No. The spreadsheet organizes information, but you should still verify products, sellers and payments independently before buying."
    },
    {
      "q": "How do I check QC photos?",
      "a": "When QC photos are available, review them for stitching, labels and visible marks, and compare them with the product description."
    },
    {
      "q": "What should I do before ordering?",
      "a": "Confirm the current price, availability, shipping cost and seller details, and read the refund or return policy before you pay."
    }
  ],
  "article.relatedTitle": "Continue Reading",
  "article.relatedBody": "Looking for more? Head back to the homepage to browse product categories, explore our resources and find more independent guides.",
  "article.ctaTitle": "Ready to Explore the USFans Spreadsheet?",
  "article.ctaBody": "Now that you understand how it works, open the USFans Spreadsheet and start researching products with confidence.",
  "article.ctaButton": "Explore USFans Spreadsheet",
  "article.author": "USFansLink Editorial Team",
  "article.categoryLabel": "Guide",
  "article.notFoundTitle": "Page Not Found",
  "article.notFound": "We could not find that article.",
  "notFound.title": "Page Not Found",
  "notFound.body": "The page you are looking for does not exist or has moved."
};